// Словарь для преобразования имён настроек в CSS-переменные
const themeVariablesMap: Record<string, string | string[]> = {
  MenuBasicColor: '--basic-color',
  MenuExtendedColor: '--extended-color',
  ThemeBackgroundColor: '--background-color',
  ButtonMainColor: '--button-main-color',
  LinkColor: '--link-color',
  HeaderFooterColor: '--header-footer-color',
  HeaderFooterTextColor: ['--header-footer-text-color', '--header-footer-link-color'],
  MenuItemTextColor: '--menu-item-text-color',
  MenuItemHoverColor: '--menu-item-hover-color',
  MenuItemHoverTextColor: '--menu-item-text-hover-color',
  MenuItemActiveColor: '--menu-item-text-active-color',
  SubmenuColor: '--submenu-color',

  // Специальные составные переменные
  MenuGradientToBottom: '--linear-gradient-color-to-bottom',
  MenuGradientToBottomRight: '--linear-gradient-color-to-bottom-right'
}

/**
 * Получает значение CSS-переменной из :root
 */
function getCssVariableValue (variableName: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim()
}

/**
 * Обновляет глобальные CSS-переменные темы
 * @param variableName - Имя переменной из словаря
 * @param newValue - Новое значение для переменной
 */
function useUpdateTheme (variableName: string, newValue: string): void {
  console.log(`Updating theme variable: ${variableName}`, newValue)

  // Обработка градиентов (требуют двух цветов)
  if (variableName === 'MenuBasicColor' || variableName === 'MenuExtendedColor') {
    const basicColor = variableName === 'MenuBasicColor'
      ? newValue
      : getCssVariableValue('--basic-color') || newValue

    const extendedColor = variableName === 'MenuExtendedColor'
      ? newValue
      : getCssVariableValue('--extended-color') || newValue

    // Обновляем градиенты
    document.documentElement.style.setProperty(
      '--linear-gradient-color-to-bottom',
      `linear-gradient(to bottom, ${basicColor}, ${extendedColor})`
    )

    document.documentElement.style.setProperty(
      '--linear-gradient-color-to-bottom-right',
      `linear-gradient(113deg, ${basicColor} 41.04%, ${extendedColor} 79.59%)`
    )
  }

  // Получаем CSS-переменные из словаря
  const cssVariables = themeVariablesMap[variableName]

  if (!cssVariables) {
    console.warn(`Переменная "${variableName}" не найдена в словаре темы`)
    return
  }

  // Обрабатываем как массив (несколько переменных для одного значения)
  if (Array.isArray(cssVariables)) {
    cssVariables.forEach(cssVar => {
      document.documentElement.style.setProperty(cssVar, newValue)
    })
  } else if (typeof cssVariables === 'string') {
    // Обычыная переменная
    document.documentElement.style.setProperty(cssVariables, newValue)
  }
}

// Экспорт функции для использования в других файлах
export default useUpdateTheme
